import StarterKit from '@tiptap/starter-kit'

export const extensions = [StarterKit]
